
import { useEffect } from 'react';
import { TeacherFormData } from '@/types/teacher.types';
import { getTeacherById } from '@/services/db/teachers';
import { toast } from 'sonner';

// Hook to fetch teacher data for editing
export const useTeacherDetails = (
  id: string | undefined,
  setFormData: (value: React.SetStateAction<TeacherFormData>) => void
) => {
  useEffect(() => {
    const fetchTeacher = async () => {
      if (id) {
        try {
          const teacher = await getTeacherById(id);
          if (teacher) {
            // Fix: Make sure required fields have default values
            setFormData({
              ...teacher,
              fatherName: teacher.fatherName || '',
              gender: teacher.gender || '',
              position: teacher.position || '',
              idNumber: teacher.idNumber || '',
              email: teacher.email || '',
              phone: teacher.phone || '',
              country: teacher.country || 'Afghanistan',
              city: teacher.city || '',
              address: teacher.address || '',
              age: teacher.age || '',
              dateOfBirth: teacher.dateOfBirth || '',
              maritalStatus: teacher.maritalStatus || '',
              // Fix: Ensure joinDate is always provided
              joinDate: teacher.joinDate || new Date().toISOString(),
              contractEndDate: teacher.contractEndDate || '',
              salary: teacher.salary || '',
              paymentStatus: teacher.paymentStatus || '',
              // Fix: Ensure profileImage is always provided
              profileImage: teacher.profileImage || '',
              departments: teacher.departments || [],
              qualifications: teacher.qualifications || [],
              documents: teacher.documents || [],
              history: teacher.history || [],
              subjects: teacher.subjects || [],
            });
          } else {
            toast.error('Teacher not found');
          }
        } catch (error) {
          console.error('Error fetching teacher:', error);
          toast.error('Failed to load teacher information');
        }
      } else {
        // Initialize with new ID if creating
        setFormData(prev => ({
          ...prev,
          id: crypto.randomUUID()
        }));
      }
    };

    fetchTeacher();
  }, [id, setFormData]);
};
